export default __webpack_public_path__ + "static/media/examBanner.0c6549e4.jpg";